import { CardModel } from './card';
import { BaseModel } from './BaseModel';

export class DeckSummaryModel extends BaseModel {
    public name: string;
    public cards: CardModel[];
    public createdBy: string;
    public createdAt: any;
    public lastupdatedAt?: any;
    public desc?: string;
    public notificationCount: number;
    public visibility: string;
}
